import * as Actions from '../../actions/users/type';

const initialState = {
  loading: false,
  getUsersloading: false,
  verified: false,
  signed: false,
  error: null,
  recentUsers: [],
  coUserData: null, // newly created user response
  allMechanics: [],
  updateWageRateSuccess: null,
  userData: '', // get user data
  updateUserSuccess: '', // when user update the account settings
  changeUserPasswordSuccess: '', // when user change the password
  changeUserPasswordError: '', // change password error
  coUsersList: [],

  getGamifications: [],
  getGamificationSuccess: '',
  addGamificationSuccess: '',
};

export const coUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.COUSER_ADD_REQUEST:
      return { ...state, loading: true };
    case Actions.COUSER_ADD_SUCCESS:
      const aray = state.recentUsers;
      aray.splice(0, 0, action.payload.data);
      return {
        ...state,
        loading: false,
        coUserData: action.payload,
        recentUsers: aray,
        error: null,
      };
    case Actions.COUSER_ADD_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.COUSER_VERIFY_REQUEST:
      return { ...state, loading: true };
    case Actions.COUSER_VERIFY_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Actions.COUSER_VERIFY_FAIL:
      return { ...state, loading: false, ...action.payload };
    case Actions.COUSER_SETUPACCOUNT_REQUEST:
      return { ...state, loading: true };
    case Actions.COUSER_SETUPACCOUNT_SUCCESS:
      return { ...state, loading: false, accountData: action.payload };
    case Actions.COUSER_SETUPACCOUNT_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.RECENT_COUSER_SUCCESS:
      action.payload.result.map((value) => {
        value.role = value.role.name;
        // delete value.Role;
      });
      return {
        ...state,
        loading: false,
        recentUsers: action.payload.result,
      };
    case Actions.RECENT_COUSER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Actions.GET_ALL_MECHANICS_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_ALL_MECHANICS_SUCCESS:
      return {
        ...state,
        loading: false,
        allMechanics: action.payload.mechanics || [],
      };
    case Actions.GET_ALL_MECHANICS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.UPDATE_ALL_MECHANICS:
      // when mechanic wage rate updated then also update then mechanics reducer

      const allMechanics = state?.allMechanics || [];
      const { id, wageRate } = action.payload;
      const index = allMechanics.findIndex((m) => m.id === id);

      if (index !== -1) {
        allMechanics[index].wageRate = wageRate;
      }
      return { ...state, allMechanics: [...allMechanics] || [] };

    // get user

    case Actions.GET_USER_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload || '',
      };
    case Actions.GET_USER_FAIL:
      return { ...state, loading: false, error: action.payload };

    // update user account settings

    case Actions.UPDATE_USER_REQUEST:
      return { ...state, loading: true };
    case Actions.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        updateUserSuccess: action.payload?.message || '',
        updateUserData: action.payload?.data || '',
      };
    case Actions.UPDATE_USER_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.UPDATE_USER_DATA:
      return {
        ...state,
        userData: action.payload?.data,
      };

    case Actions.CLEAR_UPDATE_USER_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        updateUserSuccess: '',
        coUserData: null, // created user response
      };

    // change user password

    case Actions.CHANGE_USER_PASSWORD_REQUEST:
      return { ...state, loading: true };
    case Actions.CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        changeUserPasswordSuccess: action.payload || '',
        userData: {
          ...state.userData,
          password: state.userData?.password || 'some password', // just to show oldPassword field on CHange Password Popup
        },
      };
    case Actions.CHANGE_USER_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        changeUserPasswordError: action.payload,
      };
    case Actions.CLEAR_CHANGE_USER_PASSWORD_STATE:
      return {
        ...state,
        loading: false,
        changeUserPasswordError: null,
        changeUserPasswordSuccess: '',
      };

    // update mechanic wage rate

    case Actions.UPDATE_WAGE_RATE_REQUEST:
      return { ...state, loading: true };
    case Actions.UPDATE_WAGE_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateWageRateSuccess: action.payload.message || '',
      };
    case Actions.UPDATE_WAGE_RATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // getting all co users list

    case Actions.GET_ALL_USERS_LIST_REQUEST:
      return { ...state, getUsersloading: true };
    case Actions.GET_ALL_USERS_LIST_SUCCESS:
      return {
        ...state,
        getUsersloading: false,
        coUsersList: action.payload || [],
      };
    case Actions.GET_ALL_USERS_LIST_FAIL:
      return { ...state, getUsersloading: false, error: action.payload };

    // get gamification details
    case Actions.GET_GAMIFICATION_DETAILS_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_GAMIFICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        getGamifications: action.payload || [],
        getGamificationSuccess: 'success',
      };
    case Actions.GET_GAMIFICATION_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // add/update gamification details
    case Actions.ADD_UPDATE_GAMIFICATION_DETAILS_REQUEST:
      return { ...state, loading: true };
    case Actions.ADD_UPDATE_GAMIFICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        addGamificationSuccess: 'Success' || '',
      };
    case Actions.ADD_UPDATE_GAMIFICATION_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case Actions.CLEAR_GAMIFICATION_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        addGamificationSuccess: '',
        getGamificationSuccess: '',
        getGamifications: '',
      };

    // clearing wadg Rate
    case Actions.CLEAR_WAGE_RATE_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        getUsersloading: false,
        updateWageRateSuccess: null,
      };

    default:
      return state;
  }
};
